//
// FolderInspector
//
// An inspector for a folder; we can show subfoldercount, file count, timestamps?

import { observer } from 'mobx-react-lite'
import { useStore } from '../../../stores'

import { Divider, Spacer, VView } from '../../../appview'
import { Header, Property, Text, TextInput } from '../../../components'

import { MetadataPanel } from '../../../panels'
import { validAssetName } from '../../../utils/text'

export const FolderInspector = observer(function FolderInspector({
    worksheet,
    viewkey,
}) {
    const { app, DEBUG } = useStore()

    const asset = worksheet.asset

    const renderkey = asset.gid + '.' + worksheet.language

    const onChangeAssetName = event => {
        asset.setProperty('name', event.target.value)
    }
    const onBlurAssetName = event => {
        asset.setProperty('name', event.target.value.trim())
        asset.commitIfModified()
    }

    const onChangeAssetMetadata = asset => {
        // the asset we get here is the same as the one we're working on
        asset.commitIfModified()
    }

    const Name =
        asset.pathname === '/' ? (
            <Text>{app.text('Assets')}</Text> // can't edit root name
        ) : (
            <TextInput
                autoConvert={validAssetName}
                onChange={onChangeAssetName}
                onBlur={onBlurAssetName}
                value={asset.publicname}
                renderkey={renderkey}
            />
        )

    const MetadataInspector =
        asset.pathname === '/' ? undefined : (
            <>
                <Divider />
                <MetadataPanel
                    language={worksheet.language}
                    item={asset}
                    viewkey={viewkey}
                    onChange={onChangeAssetMetadata}
                />{' '}
            </>
        )

    const DebugInfo = DEBUG ? (
        <>
            <Spacer size={5} />
            <Divider />
            <div className="DEBUG">
                <Header>{app.text('DEBUG info')}</Header>
                <Property label={app.text('gid')}>
                    <Text>{asset.gid}</Text>
                </Property>
            </div>
        </>
    ) : undefined

    return (
        <VView grow className="panel properties">
            <Header>{app.text('Main properties')}</Header>
            <Property label={app.text('name')}>{Name}</Property>
            <Property label={app.text('pathname')}>
                <Text>{asset.pathname}</Text>
            </Property>
            <Property label={app.text('subfolders')}>
                <Text>{asset.info.get('foldercount')}</Text>
            </Property>
            <Property label={app.text('files')}>
                <Text>{asset.info.get('filecount')}</Text>
            </Property>
            {MetadataInspector}
            {DebugInfo}
        </VView>
    )
})
